import { render } from "./MergingAd.vue?vue&type=template&id=4b290c3b&scoped=true"
import script from "./MergingAd.vue?vue&type=script&lang=js"
export * from "./MergingAd.vue?vue&type=script&lang=js"

import "./MergingAd.vue?vue&type=style&index=0&id=4b290c3b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b290c3b"]])

export default __exports__